import { Badge } from '@/components/ui'
import type { IntegrationOverviewEntry, IntegrationOverviewService } from '@/types/integrationsOverview'
import { entryHealthChip } from './entryHealth'

export function StatusChip({ row }: { row: IntegrationOverviewService }) {
  if (row.source === 'oauth') {
    return <Badge variant="secondary">OAuth tokens — managed by Connect</Badge>
  }
  if (row.entries.length === 0) return <Badge variant="outline">Not configured</Badge>
  if (row.entries.length === 1) {
    return <Badge variant="success">Configured via "{row.entries[0].set_name}"</Badge>
  }
  return <Badge variant="info">In {row.entries.length} sets</Badge>
}

function latestTested(entries: IntegrationOverviewEntry[]): IntegrationOverviewEntry | null {
  const tested = entries.filter((e) => e.last_tested_at)
  if (tested.length === 0) return null
  return tested.reduce((a, b) =>
    new Date(a.last_tested_at!).getTime() >= new Date(b.last_tested_at!).getTime() ? a : b
  )
}

export function HealthChip({ row }: { row: IntegrationOverviewService }) {
  if (row.source === 'oauth' || row.entries.length === 0) return null
  // Failure-dominant: a stale success on one set must not mask a failure
  // on another. Most recently tested FAILED entry wins; else most recent
  // tested entry; else never-tested copy.
  const failed = latestTested(row.entries.filter((e) => e.last_test_ok === false))
  if (failed) return entryHealthChip(failed, row.probe_available)
  const latest = latestTested(row.entries)
  if (latest) return entryHealthChip(latest, row.probe_available)
  return entryHealthChip(row.entries[0], row.probe_available)
}
